import {
    UPDATE_WEBHOOK,
    UPDATE_WEBHOOK_FAILURE,
    UPDATE_WEBHOOK_SUCCESS,
} from 'store/actions/types';

export const updateWebhook = (payload) => {
    return {
        type: UPDATE_WEBHOOK,
        payload: payload,
    };
};

export const updateWebhookFailure = (error) => {
    return {
        type: UPDATE_WEBHOOK_FAILURE,
        error: error,
    };
};

export const updateWebhookSuccess = (response) => {
    return {
        type: UPDATE_WEBHOOK_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/webhooks/updateWebhooks.js